import { css } from '@emotion/react';
import { flex, margins, themed } from '@spotnana/blocks/src/utils';
import { paddings } from '@spotnana/blocks/src/utils/styling/utilityTokens';

export const container = themed(
  ({ palette }) => css`
    ${paddings.x.extraCozy}
    ${paddings.y.extraCozy}
    ${margins.y.m2point5}
  `,
);

export const flight_summary_skeleton = css`
  ${flex.init}
  ${flex.align.center}
  ${flex.justify.between}
  width: 100%;
  ${margins.yb.m1}
`;

export const container_skeleton = css`
  ${flex.init}
  ${flex.align.center}
  width: 100%;
  ${margins.yt.m1}
`;

export const divider = css`
  ${margins.y.m1}
`;

export const airplane = css`
  ${flex.one}
  text-align: center;
`;

export const airline_info_skeleton = css`
  flex: 16;
`;

export const origin_destination_skeleton = css`
  ${flex.init}
  ${flex.column}
  ${flex.one}
  gap: 8px;
`;
